import React      from "react";
import {
  StyleSheet,
  View,
  Text,
  TouchableOpacity,
  ActivityIndicator,
} from "react-native";
import Icon       from "react-native-vector-icons/Feather";

import Row        from "~/layouts/Row";
import Col        from "~/layouts/Col";
import Heading    from "~/components/Heading/index.native";
import IconButton from "~/components/Buttons/IconButton";

import palette    from "~/styles/palette";

export default function CardHeader({
  title,
  badge,
  open,
  iconName = "info",
  onToggleOpen,
  expandable = true,
  loading=false,
}) {
  return (
    <TouchableOpacity
      activeOpacity={!expandable ? 1 : 0.5}
      onPress={onToggleOpen}
    >
      <Row center  pl={16} pr={16} style={{ height: 60, cursor: "pointer" }}>
        <Col leftCenter>
          <Row>
            <Icon
              name={iconName}
              size={18}
              style={{ paddingVertical: 10, paddingRight: 6 }}
            />
            <Heading size={5} mt={10}>
              {title}
            </Heading>
            <Badge label={badge} loading={loading} />
          </Row>
        </Col>
        <Col
          rightCenter
          maxWidth={30}
          style={{ opacity: expandable ? 1 : 0.1 }}
        >
          <IconButton
            mr={0}
            iconName={!open ? "chevron-down" : "chevron-up"}
            iconColor={palette.black}
            onPress={onToggleOpen}
          />
        </Col>
      </Row>
    </TouchableOpacity>
  );
}

const Badge = ({ label, loading=false }) => {
  return loading && !label ? (
    <View style={{paddingVertical: 10, paddingHorizontal: 8}}>
      <ActivityIndicator size="small" />
    </View>
  ) : (
    <View>
      {(label == undefined) || (label == null) ? null : (
        <View style={[styles.badge_container]}>
          <Text style={[styles.badge_text]}>{label}</Text>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  badge_container: {
    borderRadius: 20,
    height: 24,
    minWidth: 25,
    backgroundColor: palette.lightest_grey,
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    margin: 8,
  },
  badge_text: {
    color: palette.dark,
    fontSize: 14,
    fontWeight: "700",
  },
});
